module.exports = __webpack_public_path__ + "img/forgiveness-previous-film.265635cc.png";